module.exports = __webpack_public_path__ + "static/media/nima-hands-up.01200f62.png";